import { all } from "redux-saga/effects";
import { initTracker } from "modules/Tracker/services/initialization/sagas";
import { rootSagaTracks } from "modules/Tracker/services/Tracks/sagas";
import { rootSagaActions } from "modules/Tracker/services/Actions/sagas";

export function* trackerSaga() {
    yield all([
        initTracker(),
        rootSagaTracks(),
        rootSagaActions()
    ]);
}